export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5386.d6e8351c.jpg";